'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002414 from "./presto.-Freemium2-F-A-Add-View$$anon$14.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002416 from "./presto.-Freemium2-F-A-Add-View$$anon$16.js";
import * as $j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse$0024 from "./presto.types$-Configure2-F-A-Freemium-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$13() {
  this.aT9 = null;
  this.aT1 = null;
  this.aT2 = false;
  this.aTa = null;
  this.aTb = false;
  this.aTe = null;
  this.aT7 = null;
  this.aT8 = false;
  this.aT3 = null;
  this.aT4 = false;
  this.aT5 = null;
  this.aT6 = false;
  this.aTc = false;
  this.aTd = false;
  this.aT9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aTe = "Configure2FAFreemiumResponse";
}
export { $c_Lpresto_Freemium2FAAddView$$anon$13 as $c_Lpresto_Freemium2FAAddView$$anon$13 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$13;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$13() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$13 as $h_Lpresto_Freemium2FAAddView$$anon$13 };
$h_Lpresto_Freemium2FAAddView$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aT9;
});
$p.L = (function() {
  if ((!this.aT2)) {
    this.aT1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aT2 = true;
  }
  return this.aT1;
});
$p.O = (function() {
  if ((!this.aTb)) {
    this.aTa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aTb = true;
  }
  return this.aTa;
});
$p.E = (function() {
  return this.aTe;
});
$p.t = (function() {
  if ((!this.aT8)) {
    this.aT7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("results", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aT8 = true;
  }
  return this.aT7;
});
$p.M = (function() {
  if ((!this.aT4)) {
    this.aT3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002414.$c_Lpresto_Freemium2FAAddView$$anon$14())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aT4 = true;
  }
  return this.aT3;
});
$p.Q = (function() {
  if ((!this.aT6)) {
    this.aT5 = new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002416.$c_Lpresto_Freemium2FAAddView$$anon$16();
    this.aT6 = true;
  }
  return this.aT5;
});
$p.w = (function() {
  if ((!this.aTd)) {
    this.aTc = false;
    this.aTd = true;
  }
  return this.aTc;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee137) => ((p) => \u03b4scrutinee137.cGo(p)))($j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse$0024.$m_Lpresto_types$Configure2FAFreemiumResponse$())));
});
var $d_Lpresto_Freemium2FAAddView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$13, "presto.Freemium2FAAddView$$anon$13", ({
  II: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$13 as $d_Lpresto_Freemium2FAAddView$$anon$13 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$13.js.map
